import script from "./CompleteMaterialRequestDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteMaterialRequestDialog.vue?vue&type=script&setup=true&lang=js"

import "./CompleteMaterialRequestDialog.vue?vue&type=style&index=0&id=62a138ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a138ee"]])

export default __exports__